document.addEventListener("product:addedToCart", function(e) {
    addToCartIcomm(e);
});

navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
        registration.unregister();
    }
});

//Redirect based on country
$.get("https://ipinfo.io", function(response) { // we changed to https
 if (response.country !== 'undefined') {
   if (response.country == 'AU') { //AUSTRALIA
     window.location.href = "https://www.genuins.com.au/";
   }
   if (response.country == 'LB') { //LIBANO
     window.location.href = "https://www.genuinslb.com/";
   }
 }
}, "jsonp");



function addToCartIcomm(event) {
  window._imMktOptions = {
    _setType: 'Lead',
    _setDomain: 'www.news.genuins.com',
    _itemsQuantity: event.detail.quantity,
    _amount: (event.detail.final_line_price / 100).toFixed(2),
    _extraInfo: `product_id: ${event.detail.id}, variant_id: ${event.detail.variant_id}`
  };

  (function() {
    var icomMkt = document.createElement('script');
    icomMkt.type = 'text/javascript';
    icomMkt.async = true;
    icomMkt.src = (
      document.location.protocol === 'https:' 
        ? 'https://' 
        : 'http://'
    ) + 'externalassets.icommarketing.com/icomMkt_tracking_jquery.min.js';
    
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(icomMkt, s);
  })();
}